import $ from "jquery";

class MenuItem {
  $element: any;
  targetId: any;
  $target: any;
  isOpen: boolean;
  $toggle: any;
  $back: any;

  constructor(element) {
    this.$element = $(element);
    this.$toggle = $(".js-nav-item__toggle", element);
    this.$target = $(".js-nav-item__menu", element);
    this.$back = $(".js-nav-item__back", element);
    this.isOpen = false;

    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.init();
  }

  init() {
    this.$toggle.on("click", this.handleToggleClick);
    this.$back.on("click", this.handleBackClick);
    $(document).on("click", this.handleDocumentClick);
  }

  show() {
    $(`[aria-controls="${this.targetId}"]`).addClass("is-active");
    this.$target.addClass("is-active").focus();
    this.$toggle.attr("aria-expanded", true);
    this.$back.attr("aria-expanded", true);
    this.isOpen = true;
  }

  hide() {
    $(`[aria-controls="${this.targetId}"]`).removeClass("is-active");
    this.$target.removeClass("is-active");
    this.$toggle.attr("aria-expanded", false);
    this.$back.attr("aria-expanded", false);
    this.isOpen = false;
  }

  handleBackClick(e) {
    e.preventDefault();
    this.hide();
  }

  handleToggleClick(e) {
    e.preventDefault();

    if (!this.$target.hasClass("is-active")) {
      this.show();
    } else {
      this.hide();
    }
  }

  handleDocumentClick(e) {
    // Hide menu if click outside
    if (!this.$element[0].contains(e.target)) {
      this.hide();
    }
  }
}

export default MenuItem;
